const url = "/ptamonitoras";
const urlTiposRestricoes = "/tiporestricoes";
const id = "idenPtaMonitora";

export const initForm = {
  idenPtaMonitora: 0,
  flagPrioritario: null,
  dataInicioRealizado: "",
  dataFinalRealizado: "",

  ptaFiplan: {
    idenPtaFiplan: null,
    descElemento: null,
    tipoItemPta: { descTipoItemPta: null, siglTipoItemPta: null, flagAndamento: null, flagRestricaoProvidencia: null },
    produto: { idenProduto: null, descProduto: null, codgProduto: null, descricaoFiplan: null },
    programa: { descJustificativa: null, descPublicoAlvo: null, nomeResponavel: null, objetivos: [{ nomeObjetivo: null }] },
    unidadeMedida: { descUnidadeMedida: null },
    uo: { idenUo: null, siglUo: null, descUo: null, descricaoFiplan: null },
    dataInicioPrevisto: "",
    dataTerminoPrevisto: "",
  },
  pessoaResp: { nomePessoa: "Não Informado" },
  status: { idenStatus: null, descStatus: null, tipoCor: null },
  produtoAcao: { acao: null, produtoAcao: null },
  unidadeSeap: { idenUnidade: null, descUnidade: null },
  subUnidadeSeap: { idenUnidade: null, descUnidade: null },
  unidadeOrcamentaria: { idenUo: null, codgUo: null },
};


export function pesquisarPorId(idenPtaMonitora) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${idenPtaMonitora}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarUnidadesExecucaoSeap(codgUo, idenExercicio) {
  return new Promise((resolve, reject) => {
    window.$http.get(`unidadesexecucaoseap?codgUo=${codgUo}&idenExercicio=${idenExercicio}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarSubUnidadesExecucaoSeap(codgUo, idenExercicio, idenSetorPai) {
  return new Promise((resolve, reject) => {
    window.$http
      .get(`unidadesexecucaoseap?codgUo=${codgUo}&idenExercicio=${idenExercicio}&idenSetorPai=${idenSetorPai}`)
      .then((res) => {
        resolve(res.data);
      });
  });
}

export function buscarPeloIdenPtaPaiFiplan(idenPtaFiplan) {
  return new Promise((resolve, reject) => {
    window.$http.get(`ptamonitoras/buscarPeloIdenPtaPaiFiplan/${idenPtaFiplan}`).then((res) => {
      resolve(res.data);
    });
  });
}
